import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { Check, ShieldCheck, Lock } from 'lucide-react';
import { PriceDisplay } from './PriceDisplay';
import { CTAButton } from './CTAButton';
import { TestimonialGrid } from './TestimonialGrid';
import { useGeoPrice } from '../lib/pricing';
const valueStack = [{
  label: '+600 Planos Metálicos con medidas exactas',
  usdValue: 49.99
}, {
  label: 'Bono #1: Checklist CERO ERROR',
  usdValue: 9.99
}, {
  label: 'Bono #2: Ruta Express 7 Días',
  usdValue: 14.99
}, {
  label: 'Bono #3: Planos de Trailers y Gym',
  usdValue: 19.99
}, {
  label: 'Bono #4: Aprende a Soldar',
  usdValue: 14.99
}, {
  label: 'Bono #5: Presupuesto y Ventas',
  usdValue: 19.99
}, {
  label: 'Bono #6: Torneria Desde Cero',
  usdValue: 12.99
}, {
  label: 'Bono #7: Herrería Artística',
  usdValue: 14.99
}, {
  label: 'Bono #8: Carpintería Que Vende',
  usdValue: 19.99
}];
const TOTAL_USD_VALUE = valueStack.reduce((sum, item) => sum + item.usdValue, 0);
export function PricingSection() {
  const {
    pricing,
    formatPrice,
    convertCompareFromUSD
  } = useGeoPrice();
  return <section id="resumen-oferta" className="py-8 px-4 bg-[#0d0d0d] relative" data-id="element-159">
      <div className="max-w-3xl mx-auto" data-id="element-160">
        {/* Intro */}
        <div className="text-center mb-6" data-id="element-161">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-4" data-id="element-162">
            ¿CUÁNTO CUESTA{' '}
            <span className="text-[#FF6B00] underline decoration-4 decoration-[#FF6B00]/30 underline-offset-4" data-id="element-163">
              TODO ESTO?
            </span>
          </h2>
          <p className="text-gray-400 max-w-2xl mx-auto text-base leading-relaxed mb-3" data-id="element-164">
            Cuando los cursos online cobran{' '}
            <span className="text-white font-bold" data-id="element-165">$200 o $500</span> por
            enseñarte solo TEORÍA <br className="md:hidden" data-id="element-166" />
            sin un solo plano utilizable...
            <br data-id="element-167" />
            <br data-id="element-168" />
            es natural pensar que un paquete con{' '}
            <span className="text-white font-bold" data-id="element-169">
              +600 planos y 8 bonos
            </span>{' '}
            será impagable.
          </p>
          <p className="text-white font-bold text-lg" data-id="element-170">
            Sin embargo,{' '}
            <span className="text-[#FF6B00] uppercase" data-id="element-171">¡NO lo es!</span>{' '}
            <br className="md:hidden" data-id="element-172" />
            Lo correcto era hacerlo{' '}
            <span className="underline decoration-[#FF6B00] decoration-2" data-id="element-173">
              accesible para TODOS
            </span>
            , así que estoy ofreciendo un descuento especial de lanzamiento{' '}
            <span className="italic" data-id="element-174">por tiempo limitado...</span>
          </p>
        </div>

        {/* Value Stack Card */}
        <motion.div initial={{
        scale: 0.95,
        opacity: 0
      }} whileInView={{
        scale: 1,
        opacity: 1
      }} viewport={{
        once: true
      }} className="bg-[#1a1a1a] border-2 border-[#FF6B00] rounded-2xl overflow-hidden shadow-[0_0_50px_rgba(255,107,0,0.15)] relative" data-id="element-175">
          <div className="absolute top-0 right-0 bg-[#EF4444] text-white px-12 py-1 transform rotate-45 translate-x-14 translate-y-8 font-black shadow-lg z-10 text-sm uppercase tracking-widest border border-white/20" data-id="element-176">
            OFERTA
          </div>

          <div className="p-5 md:p-6 border-b border-[#333]" data-id="element-177">
            <div className="mb-4" data-id="element-178">
              <div style={{
              aspectRatio: '800 / 450'
            }} className="relative" data-id="element-179">
                <img src="https://cdn.magicpatterns.com/uploads/36y6WSBrnoWDsuX6jHqshM/ChatGPT_Image_11_feb_2026,_04_40_03_p.m..webp" alt="Sistema Maestro de Herrería — Paquete completo de planos, bonos y herramientas" className="w-full h-full rounded-lg object-cover" loading="lazy" decoding="async" width={800} height={450} data-id="element-180" />
              </div>
            </div>
            <h3 className="text-2xl font-bold text-white text-center mb-4 uppercase tracking-wide" data-id="element-181">
              Todo Lo Que Obtenés:
            </h3>
            <div className="space-y-2" data-id="element-182">
              {valueStack.map((item, i) => <div key={i} className="flex items-center justify-between text-sm md:text-base py-2 border-b border-[#333]/50 last:border-0 border-dashed" data-id="element-183">
                  <div className="flex items-center text-gray-200" data-id="element-184">
                    <Check className="w-5 h-5 text-[#22C55E] mr-3 flex-shrink-0" data-id="element-185" />
                    <span className={i === 0 ? 'font-bold text-white' : ''} data-id="element-186">
                      {item.label}
                    </span>
                  </div>
                  <span className="text-gray-500 line-through text-xs md:text-sm ml-2 flex-shrink-0 font-mono" data-id="element-187">
                    {formatPrice(convertCompareFromUSD(item.usdValue))}
                  </span>
                </div>)}
            </div>
            <div className="flex items-center justify-between mt-4 pt-3 border-t border-[#FF6B00]/30" data-id="element-188">
              <span className="font-bold text-white text-lg" data-id="element-189">Valor Total:</span>
              <span className="text-gray-400 line-through font-bold text-xl decoration-red-500/50 decoration-2" data-id="element-190">
                {formatPrice(convertCompareFromUSD(TOTAL_USD_VALUE))}
              </span>
            </div>
          </div>

          <div className="p-6 bg-[#222] text-center" data-id="element-191">
            <p className="text-gray-400 text-sm mb-2 font-medium uppercase tracking-wide" data-id="element-192">
              Hoy accedés por un pago único de:
            </p>
            <div className="mb-4" data-id="element-193">
              <PriceDisplay amount={16.99} className="text-5xl md:text-8xl font-black text-[#FF6B00] tracking-tighter drop-shadow-lg" data-id="element-194" />
            </div>

            <CTAButton size="xl" className="w-full md:w-auto shadow-xl mb-3 text-xl" href="https://carlosponte.com/cart/add?id=56937498575173&quantity=1" data-id="element-195">
              AGREGAR AL CARRITO
            </CTAButton>
            <p className="text-sm text-gray-400 mb-3 font-medium" data-id="element-196">
              Acceso Inmediato a +600 Planos + 8 Bonos &gt;&gt;
            </p>
            <div className="flex flex-col gap-1 items-center justify-center" data-id="element-197">
              <p className="text-xs text-gray-400 font-bold bg-[#111] px-3 py-1 rounded-full border border-[#333] inline-block" data-id="element-198">
                <Lock className="w-3 h-3 inline mr-1 mb-0.5" data-id="element-199" />
                Pago único. SIN cargos mensuales. SIN costos ocultos.
              </p>
              <p className="text-xs text-gray-600 mt-2 italic max-w-sm mx-auto" data-id="element-200">
                Me reservo el derecho de cerrar este descuento en cualquier
                momento después del 25 de febrero de 2026.
              </p>
            </div>
          </div>
        </motion.div>

        {/* Urgency text */}
        <p className="text-gray-400 text-sm text-center mt-5 max-w-xl mx-auto italic" data-id="element-201">
          Eso es toda una vida de proyectos de herrería{' '}
          <br className="md:hidden" data-id="element-202" />
          al alcance de tu mano por el precio de{' '}
          <span className="text-white font-bold not-italic" data-id="element-203">
            un almuerzo.
          </span>{' '}
          <br className="md:hidden" data-id="element-204" />
          <span className="text-[#EF4444] font-bold not-italic" data-id="element-205">
            Pero esta oferta cerrará pronto
          </span>{' '}
          y no vas a poder entrar a este precio después.
        </p>

        {/* Guarantee */}
        <div className="mt-8" data-id="element-206">
          <h3 className="text-xl md:text-3xl font-bold text-white text-center mb-3" data-id="element-207">
            No Digas "Sí". Solo Decí <br className="md:hidden" data-id="element-208" />
            "Quizás" &{' '}
            <span className="text-[#22C55E] underline decoration-[#22C55E]/30" data-id="element-209">
              Probalo SIN RIESGO
            </span>
          </h3>
          <p className="text-gray-400 text-sm text-center mb-4" data-id="element-210">
            No te voy a dar una "garantía" vacía. <br className="md:hidden" data-id="element-211" />
            Te hago una{' '}
            <span className="text-white font-bold italic" data-id="element-212">
              promesa personal:
            </span>
          </p>
          <div className="p-5 border border-[#333] rounded-xl bg-[#111] flex flex-col md:flex-row gap-4 items-center shadow-lg" data-id="element-213">
            <ShieldCheck className="w-20 h-20 text-[#FF6B00] flex-shrink-0 drop-shadow-[0_0_15px_rgba(255,107,0,0.3)]" data-id="element-214" />
            <div className="text-center md:text-left" data-id="element-215">
              <h4 className="text-xl font-bold text-white mb-2" data-id="element-216">
                🛡️ Garantía de 120 Días: <br className="md:hidden" data-id="element-217" />
                "ÁMALO O DÉJALO" —{' '}
                <span className="underline decoration-[#22C55E]" data-id="element-218">
                  100% Satisfacción
                </span>
              </h4>
              <p className="text-gray-400 text-base leading-relaxed" data-id="element-219">
                Si este no es el recurso de herrería{' '}
                <span className="text-white font-bold" data-id="element-220">más completo</span> que
                hayas visto, escribíme y{' '}
                <span className="text-white font-bold underline decoration-[#FF6B00]" data-id="element-221">
                  te devuelvo el 100% de tu dinero.
                </span>
                <br data-id="element-222" />
                <br data-id="element-223" />
                Sin preguntas. Sin letra pequeña. Sin condiciones.{' '}
                <br className="md:hidden" data-id="element-224" />
                El riesgo es{' '}
                <span className="text-white font-bold underline decoration-[#FF6B00]" data-id="element-225">
                  CERO
                </span>{' '}
                para vos.
              </p>
            </div>
          </div>
        </div>

        {/* Testimonials — social proof before final decision */}
        <div className="mt-8 -mx-4 md:mx-0" data-id="element-226">
          <TestimonialGrid data-id="element-227" />
        </div>

        {/* Decision / Final CTA */}
        <div className="mt-8 text-center space-y-4" data-id="element-228">
          <p className="text-white font-bold text-xl" data-id="element-229">
            Tenés una decisión que tomar. <br className="md:hidden" data-id="element-230" />Y creo que
            es{' '}
            <span className="underline decoration-[#FF6B00] decoration-2" data-id="element-231">
              fácil.
            </span>
          </p>
          <p className="text-gray-400 text-base max-w-xl mx-auto leading-relaxed" data-id="element-232">
            Por el precio de un café con postre, eliminás{' '}
            <span className="text-white font-bold" data-id="element-233">
              TODOS los dolores de cabeza
            </span>{' '}
            de fabricar muebles profesionales —{' '}
            <span className="text-white font-bold" data-id="element-234">PARA SIEMPRE.</span>
            <br data-id="element-235" />
            <br data-id="element-236" />
            Después de ordenar obtenés{' '}
            <span className="text-[#FF6B00] font-bold underline decoration-[#FF6B00]/40" data-id="element-237">
              ACCESO INMEDIATO.
            </span>{' '}
            <br className="md:hidden" data-id="element-238" />
            Sin esperar envíos. <br className="md:hidden" data-id="element-239" />
            Podés empezar tu primer proyecto{' '}
            <span className="italic" data-id="element-240">en minutos.</span>
          </p>

          <CTAButton size="xl" className="w-full md:w-auto shadow-xl" href="https://carlosponte.com/cart/add?id=56937498575173&quantity=1" data-id="element-241">
            AGREGAR AL CARRITO
          </CTAButton>
          <p className="text-xs text-gray-500" data-id="element-242">
            Pago único. Me reservo el derecho de cerrar este descuento después
            del 25 de febrero de 2026.
          </p>

          {/* P.D. */}
          <div className="text-left bg-[#1a1a1a] p-5 rounded-lg border border-[#333] mt-5 space-y-3 text-sm text-gray-400 shadow-inner" data-id="element-243">
            <p data-id="element-244">
              <span className="text-white font-bold bg-[#333] px-1 rounded mr-1" data-id="element-245">
                P.D:
              </span>{' '}
              Recordá: tenés mi{' '}
              <span className="text-white font-bold underline decoration-[#FF6B00]/50" data-id="element-246">
                Garantía 100% Libre de Riesgo.
              </span>{' '}
              <br className="md:hidden" data-id="element-247" />
              Estoy 110% seguro de que vas a estar más contento que un niño en
              Navidad con tus planos. <br className="md:hidden" data-id="element-248" />
              Pero si no, tu inversión está garantizada por{' '}
              <span className="text-white font-bold" data-id="element-249">120 días completos.</span>
            </p>
            <p data-id="element-250">
              <span className="text-[#EF4444] font-bold bg-[#EF4444]/10 px-1 rounded mr-1" data-id="element-251">
                P.P.D:
              </span>{' '}
              ¡OFERTA SENSIBLE AL TIEMPO! <br className="md:hidden" data-id="element-252" />
              No vas a tener la oportunidad de invertir en este paquete a este
              precio una vez que termine. <br className="md:hidden" data-id="element-253" />
              <span className="text-white font-bold underline decoration-[#EF4444]" data-id="element-254">
                El precio sube a {formatPrice(pricing.compareAt)} y será
                permanente.
              </span>
            </p>
          </div>
        </div>
      </div>
    </section>;
}